import ModelUtil from '@leverege/model-util';
import SelectionTypeModel from "./SelectionTypeModel.js";
const TYPE = 'detail.Selection';
function getType(model, type) {
  return model?.types?.[type];
}

// separate the details and the layout for them so
// i can reuse the detail part

function create() {
  return {
    type: TYPE,
    visible: true,
    margin: '24px',
    placement: 'top-right',
    types: {}
  };
}
const mod = {
  TYPE,
  create,
  getType,
  addType,
  getPlacementForType,
  ...ModelUtil.createAllValue('visible'),
  ...ModelUtil.createAllValue('placement'),
  ...ModelUtil.createAllValue('margin'),
  ...ModelUtil.createAllMap('types', 'type', 'types')
};
function addType(model, type) {
  return mod.types().set(model, type, SelectionTypeModel.create(type));
}
function getPlacementForType(model, type) {
  if (type && model.types[type]) {
    const m = model.types?.[type];
    return m.placement || model.placement || 'bottom-left';
  }
  return model.placement || 'top-left';
}
export default mod;